import EditRateOptionDialog from './EditRateOptionDialog'

export default EditRateOptionDialog
